export default __webpack_public_path__ + "alberta-attachment.0f7a81a9e8e647f5b86b.svg";